import { FC } from 'react'
import styled from '@emotion/styled'

const Container = styled('div')(({ theme }) => ({
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'transparent',
  padding: `${theme.spacing.xs + 2}px ${theme.spacing.xs}px`,
  cursor: 'text',
  '&:hover': {
    borderColor: theme.colors.primary.main,
  },
}))

interface ChatPreviewEditableDescriptionProps {
  children: string
  onClick: () => void
}

export const ChatPreviewEditableDescription: FC<ChatPreviewEditableDescriptionProps> = ({ children, onClick }) => {
  return <Container onClick={onClick}>{children}</Container>
}
